// Match Height Js
window.pdpSwiper = false;

// Match Height Js Start
window.matchHeight = function (className) {
  // Allow some time for layout to settle
  setTimeout(function () {
    var elements = document.querySelectorAll("." + className);
    if (!elements.length) return;

    // Reset heights first
    elements.forEach(function (element) {
      element.style.height = "auto";
    });

    // Group elements by their vertical position
    var rows = [];
    var currentRow = [];
    var currentTop = null;
    var threshold = 5; // Small threshold to account for minor differences

    // Sort elements by their vertical position
    var sortedElements = Array.from(elements);
    sortedElements.sort(function (a, b) {
      return a.getBoundingClientRect().top - b.getBoundingClientRect().top;
    });

    sortedElements.forEach(function (element) {
      var rect = element.getBoundingClientRect();

      if (currentTop === null) {
        // First element
        currentRow.push(element);
        currentTop = rect.top;
      } else if (Math.abs(rect.top - currentTop) <= threshold) {
        // Same row (within threshold)
        currentRow.push(element);
      } else {
        // New row
        rows.push(currentRow);
        currentRow = [element];
        currentTop = rect.top;
      }
    });

    // Don't forget the last row
    if (currentRow.length > 0) {
      rows.push(currentRow);
    }

    // Set the max height for each row
    rows.forEach(function (row) {
      var maxHeight = 0;

      // Find the max height in this row
      row.forEach(function (element) {
        // Force reflow to ensure correct height calculation
        element.style.height = "auto";
        var height = element.offsetHeight;
        maxHeight = Math.max(maxHeight, height);
      });

      // Apply the max height to all elements in this row
      if (maxHeight > 0) {
        row.forEach(function (element) {
          element.style.height = maxHeight + "px";
        });
      }
    });
  }, 50); // Small delay to ensure DOM is ready
};
// Match Height Js End


// Debounce function to limit how often a function can run
function debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            func.apply(context, args);
        }, wait);
    };
}

// Function to apply height matching to all relevant elements
function applyMatchHeight() {
    matchHeight('card__inner');
    matchHeight('card__heading');
}

// Apply matchHeight on load
window.addEventListener('load', applyMatchHeight);

// Apply matchHeight on resize (with debounce)
window.addEventListener('resize', debounce(applyMatchHeight, 250));


document.addEventListener("DOMContentLoaded", function () {
  new WOW().init();
});